import { makeStyles } from "tss-react/mui";
const useStyles = makeStyles()((theme, { row })=>({
        labelBox: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            marginBottom: row ? theme.tokens.spacing['0'] : theme.tokens.spacing['8']
        },
        label: {
            position: 'relative',
            display: 'flex',
            alignItems: 'center',
            transform: 'translate(0, 1.5px)',
            textOverflow: 'unset',
            whiteSpace: 'normal',
            overflow: 'unset'
        },
        required: {
            '&::after': {
                content: "'*'",
                color: theme.tokens.colors.original.brand.primary,
                marginLeft: theme.px(5)
            }
        }
    }));
const Label_styles = useStyles;
export default Label_styles;
